/* 🤖 this file was generated by svg-to-ts */
export const matIconLooks6: {
  name: 'looks-6';
  data: string;
} = {
  name: 'looks-6',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 17h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2zm0-4h2v2h-2v-2zm8-10H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/></svg>`
};
